import React, { useState, useEffect, useContext } from 'react';
import { JobAppContext } from '../../GlobalState';
import { useContacts, useUpdateLocations } from '../../hooks';

export const ContactField = ({
	value = "0",
	change,
	readOnly,
	divId // We need the division ID to fetch contacts
}) => {
	const { apiKey } = useContext(JobAppContext);
	
	// Use react-query hooks (contacts for first location are prefetched by NcsDataPrefetcher)
	const { data: contacts = [], isLoading: loadingContacts } = useContacts(divId, apiKey);
	const { updateLocations } = useUpdateLocations();

	const [ selectedContact, setSelectedContact ] = useState(value);

	useEffect(() => {
		if ( selectedContact && selectedContact !== 0 ) {
			updateLocations(selectedContact, apiKey);
		}
	}, [selectedContact]);

	useEffect(() => {
		setSelectedContact(value);
	}, [value])

	// Derive contact label from selectedContact and contacts
	const contact_label = (() => {
		if (selectedContact == 0) {
			return '< No Contact Selected >';
		}
		const found = contacts.find(cont => cont.CNT_ID == selectedContact);
		return found ? found.CONTACT : `Description Not Found (${selectedContact})`;
	})();

	const onChange = (e) => {
		setSelectedContact(e.target.value);
		change(e);
	}

	return (
		<div className="form-row mb-3">
			<div className="col">
				{loadingContacts ? (
					<>
						<i className="fas fa-sync-alt fa-spin mr-1" ></i> 
						Loading Contacts
					</>
				) : (
					<div className="Input">
						<label>
							Contact
							<i className="fa fa-info-circle ml-2" title="This is the user who will be the contact for this project in OLS"></i>
						</label>
						{readOnly ? (
							<span>{contact_label}</span>
						) : (
							<select
								name="selectedContact"
								value={selectedContact}
								className="selectInput form-control"
								onChange={e => onChange(e)}
							>
								<option value="0">{'< No Contact Set >'}</option>
								{contacts?.map((contact, index) => (
									<option key={index} value={contact.CNT_ID}>
										{contact.CONTACT}
									</option>
								))}
							</select>
						)}
					</div>
				)}
			</div>
		</div>
	)
}